<header>
    <div class="header">
        <nav class="navbar navbar-expand-xl w-100">
            <div class="navbar-title">
                <a class="logo" href="#">
                    <img src="../../assets/images/worlderp-inc-logo.png" alt="WorldERP logo">
                    <div>
                        <p class="fw-bold">WorldERP.com</p>
                        <p>Pioneers of Hyper-Automation</p>
                    </div>
                </a>
                <button class="navbar-toggler d-xl-none" type="button" data-toggle="collapse" data-target="#navbarToggler" aria-controls="navbarToggler" aria-expanded="false" aria-label="Toggle navigation">
                    <a class="mobile-menu-button">
                        <div></div>
                        <div></div>
                        <div></div>
                    </a>
                </button>
            </div>
            <div class="collapse navbar-collapse" id="navbarToggler">
                <ul class="navbar-nav m-auto align-items-center">
                    <li class="nav-item">
                        <a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" routerLink="" class="nav-link">Home</a>
                    </li>
                    <li class="nav-item">
                        <a routerLinkActive="active" routerLink="solutions" class="nav-link">Solutions</a>
                    </li>
                    <!--<li class="nav-item dropdown d-flex flex-column align-items-center">
                        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Benefits</a>
                        <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                            <a class="dropdown-item w-auto" href="#">All Users</a>
                            <a class="dropdown-item w-auto" href="#">Clients</a>
                            <a class="dropdown-item w-auto" href="#">Vendors/Contractors</a>
                        </div>
                    </li>-->
                    <li class="nav-item">
                        <a routerLinkActive="active" routerLink="about" class="nav-link">About</a>
                    </li>
                    <li class="nav-item">
                        <a routerLinkActive="active" routerLink="contact-us" href="#" class="nav-link">Contact Us</a>
                    </li>
                </ul>
                <div class="wrp-btn mobile">
                    <!--<a href="#" class="btn btn-long btn-primary">Vendors/Contractors</a>
                    <a href="#" class="btn btn-long btn-outline-info">Clients</a>-->
                </div>
            </div>
        </nav>
        <div class="wrp-btn" style="min-width: 432px;">
            <!--<a href="#" class="btn btn-long btn-primary">Vendors/Contractors</a>
            <a href="#" class="btn btn-long btn-outline-info">Clients</a>-->
        </div>
    </div>
</header>
